
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE } from '../core/core.module'

import { AvatarService } from './avatar.service'
import { AvatarSizeService } from './avatar-size.service'

@NgModule({
  imports: [
	CommonModule
  ],
  providers: [
    AvatarService,
    AvatarSizeService,
  ]
})
export class SeAvatarModule { }

export const SE_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.avatar`

